// Entry point for the build script in your package.json
import "bootstrap-icons/font/bootstrap-icons.css"

if (typeof document !== "undefined") {
  import("bootstrap")
}

const style = 'background-color: #fa5260; color: white; border-radius: 5px; padding: 4px 6px'
console.log("Powered by Synsbasen %cAPI", style, '\n\nRead more at: http://api.synsbasen.dk');
